import LandingPage from './LandingPage';

const LandingConfig = {
  settings: {
    layout: {
      config: {
        navbar: { display: false },
        toolbar: { display: false },
        footer: { display: false },
        leftSidePanel: { display: false },
        rightSidePanel: { display: false },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: 'landing',
      element: <LandingPage />,
    },
  ],
};

export default LandingConfig;
